import { createSelector } from '@ngrx/store';

import { eplusSustainabilityFeature } from '../sustainability.state';

export const selectRabobankFormState = createSelector(
  eplusSustainabilityFeature,
  (state) => state.rabobankForm
);

export const selectRabobankSubmitState = createSelector(
  selectRabobankFormState,
  (state) => state.submitState
);

export const selectRabobankRedirectUrl = createSelector(
  selectRabobankFormState,
  (state) => state.redirectUrl
);
